var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.213,
    height: 16.149,
    viewBox: "0 0 13.213 16.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M3.67,7.341H9.543v-2.2a2.829,2.829,0,0,0-.86-2.076A2.829,2.829,0,0,0,6.607,2.2a2.829,2.829,0,0,0-2.076.86,2.829,2.829,0,0,0-.86,2.076Zm9.543,1.1v6.607a1.1,1.1,0,0,1-1.1,1.1H1.1a1.062,1.062,0,0,1-.78-.321A1.062,1.062,0,0,1,0,15.048V8.442a1.062,1.062,0,0,1,.321-.78,1.062,1.062,0,0,1,.78-.321h.367v-2.2A4.945,4.945,0,0,1,2.982,1.514,4.945,4.945,0,0,1,6.607,0a4.945,4.945,0,0,1,3.624,1.514,4.945,4.945,0,0,1,1.514,3.624v2.2h.367a1.1,1.1,0,0,1,1.1,1.1Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a8113ba0aab9fbcdf8b8778c6e564e9c.svg";
export { ForwardRef as ReactComponent };